'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './webaccess-list-ss.routes';

export class WebaccessListSsComponent {
  constructor(Auth, WebAccessService, SettingsService, dialogs, $localStorage, DTOptionsBuilder, $scope, $uibModal, DTState,
              DTColumnBuilder, $timeout) {
    'ngInject';

    this.WebAccessService = WebAccessService;
    this.data = [];
    this.filteredData = [];
    this.activeTabIndex = 0;
    this.$uibModal = $uibModal;
    this.$timeout = $timeout;
    this.stats = {};

    SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.webAccessGroupConfig = appSettings.data.webAccessGroupConfig || [];
    });

    this.valueMap = {
      email: {},
      contact: {}
    };

    this.dialogs = dialogs;

    this.dtColumns = [];

    const that = this;

    this.dtColumns.push(DTColumnBuilder.newColumn("email").withTitle('Login'));
    this.dtColumns.push(DTColumnBuilder.newColumn("contact").withTitle('Contact'));

    this.dtOptionsSS = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('order', this.defaultOrder)
      .withOption('pagingType', 'full_numbers')
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
            return;

          params.search.fields = ["email", "contact.firstName", "contact.lastName", "contact.company", "contact.lastName, contact.firstName"];
        }

        that.WebAccessService.querySS(params, result => {

          if (params.search && params.search.value) {
            let searchTerms = params.search.value.split(",").map(t => t.trim());
            that.buildValueMap(result.data, true, searchTerms);
          } else {
            that.buildValueMap(result.data);
          }

          console.log(result);

          that.filteredDataSS = result.data;

          this.stats.all = result.recordsTotal;

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtAll').DataTable().columns.adjust();
          }, 0);
        })
      });

    this.dtOptionsActive = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('order', this.defaultOrder)
      .withOption('pagingType', 'full_numbers')
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
            return;

          params.search.fields = ["email", "contact.firstName", "contact.lastName", "contact.company", "contact.lastName, contact.firstName"];
        }

        params.view = "active";

        that.WebAccessService.querySS(params, result => {

          if (params.search && params.search.value) {
            let searchTerms = params.search.value.split(",").map(t => t.trim());
            that.buildValueMap(result.data, true, searchTerms);
          } else {
            that.buildValueMap(result.data);
          }

          console.log(result);

          that.filteredDataActive = result.data;

          this.stats.active = result.recordsTotal;

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtActive').DataTable().columns.adjust();
          }, 0);
        })
      });

    this.dtOptionsBlocked = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('order', this.defaultOrder)
      .withOption('pagingType', 'full_numbers')
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
            return;

          params.search.fields = ["email", "contact.firstName", "contact.lastName", "contact.company", "contact.lastName, contact.firstName"];
        }

        params.view = "blocked";

        that.WebAccessService.querySS(params, result => {

          if (params.search && params.search.value) {
            let searchTerms = params.search.value.split(",").map(t => t.trim());
            that.buildValueMap(result.data, true, searchTerms);
          } else {
            that.buildValueMap(result.data);
          }

          console.log(result);

          that.filteredDataBlocked = result.data;

          this.stats.blocked = result.recordsTotal;

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtBlocked').DataTable().columns.adjust();
          }, 0);
        })
      });
    this.dtOptionsBlocked = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('order', this.defaultOrder)
      .withOption('pagingType', 'full_numbers')
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
            return;

          params.search.fields = ["email", "contact.firstName", "contact.lastName", "contact.company", "contact.lastName, contact.firstName"];
        }

        params.view = "blocked";

        that.WebAccessService.querySS(params, result => {

          if (params.search && params.search.value) {
            let searchTerms = params.search.value.split(",").map(t => t.trim());
            that.buildValueMap(result.data, true, searchTerms);
          } else {
            that.buildValueMap(result.data);
          }

          console.log(result);

          that.filteredDataBlocked = result.data;

          this.stats.blocked = result.recordsTotal;

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtBlocked').DataTable().columns.adjust();
          }, 0);
        })
      });

    this.dtOptionsInitial = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('order', this.defaultOrder)
      .withOption('pagingType', 'full_numbers')
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
            return;

          params.search.fields = ["email", "contact.firstName", "contact.lastName", "contact.company", "contact.lastName, contact.firstName"];
        }

        params.view = "initial";

        that.WebAccessService.querySS(params, result => {

          if (params.search && params.search.value) {
            let searchTerms = params.search.value.split(",").map(t => t.trim());
            that.buildValueMap(result.data, true, searchTerms);
          } else {
            that.buildValueMap(result.data);
          }

          console.log(result);

          that.filteredDataInitial = result.data;

          this.stats.initial = result.recordsTotal;

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtInitial').DataTable().columns.adjust();
          }, 0);
        })
      });

    this.dtOptionsBlocked = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('order', this.defaultOrder)
      .withOption('pagingType', 'full_numbers')
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
            return;

          params.search.fields = ["email", "contact.firstName", "contact.lastName", "contact.company", "contact.lastName, contact.firstName"];
        }

        params.view = "blocked";

        that.WebAccessService.querySS(params, result => {

          if (params.search && params.search.value) {
            let searchTerms = params.search.value.split(",").map(t => t.trim());
            that.buildValueMap(result.data, true, searchTerms);
          } else {
            that.buildValueMap(result.data);
          }

          console.log(result);

          that.filteredDataBlocked = result.data;

          this.stats.blocked = result.recordsTotal;

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtBlocked').DataTable().columns.adjust();
          }, 0);
        })
      });

    this.dtOptionsInviteNoActivation = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('order', this.defaultOrder)
      .withOption('pagingType', 'full_numbers')
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
            return;

          params.search.fields = ["email", "contact.firstName", "contact.lastName", "contact.company", "contact.lastName, contact.firstName"];
        }

        params.view = "invite-no-activation";

        that.WebAccessService.querySS(params, result => {

          if (params.search && params.search.value) {
            let searchTerms = params.search.value.split(",").map(t => t.trim());
            that.buildValueMap(result.data, true, searchTerms);
          } else {
            that.buildValueMap(result.data);
          }

          console.log(result);

          that.filteredDataInviteNoActivation = result.data;

          this.stats.inviteNoActivation = result.recordsTotal;

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtInviteNoActivation').DataTable().columns.adjust();
          }, 0);
        })
      });

    this.dtOptionsNoInviteNoActivation = DTOptionsBuilder.newOptions()
      //.withOption('dom', 'lBfrtip')
      .withOption('serverSide', true)
      //.withOption('processing', true)
      //.withDataProp('data')
      //.withOption('stateSave', true)
      //.withOption('stateSaveCallback', DTState.save())
      //.withOption('stateLoadCallback', DTState.restore())
      .withOption('order', this.defaultOrder)
      .withOption('pagingType', 'full_numbers')
      .withOption('pageLength', 10)
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
      .withOption('ajax', (params, cb) => {

        console.log("enter", params);

        if (params.search) {
          if (params.search.value.endsWith(" ") || params.search.value.endsWith(","))
            return;

          params.search.fields = ["email", "contact.firstName", "contact.lastName", "contact.company", "contact.lastName, contact.firstName"];
        }

        params.view = "no-invite-no-activation";

        that.WebAccessService.querySS(params, result => {

          if (params.search && params.search.value) {
            let searchTerms = params.search.value.split(",").map(t => t.trim());
            that.buildValueMap(result.data, true, searchTerms);
          } else {
            that.buildValueMap(result.data);
          }

          console.log(result);

          that.filteredDataNoInviteNoActivation = result.data;

          this.stats.noInviteNoActivation = result.recordsTotal;

          cb({
            recordsTotal: result.recordsTotal,
            recordsFiltered: result.recordsFiltered,
            data: []
          });

          that.$timeout(_=>{
            $('#dtNoInviteNoActivation').DataTable().columns.adjust();
          }, 0);
        })
      });

  }


  buildValueMap(data, highlight, searchTerms) {
    data.forEach(wa => {
      this.valueMap.email[wa._id] = wa.email;
      this.valueMap.contact[wa._id] = this.getComposedName(wa.contact);

      if (highlight && searchTerms && searchTerms.length) {
        searchTerms.sort(function (a, b) {
          return b.length - a.length;
        });

        var regexFirst = new RegExp(searchTerms[0], 'i');
        var regexAll = new RegExp('(' + searchTerms.join('|') + ')', 'gi');

        this.valueMap.email[wa._id] = this.valueMap.email[wa._id].replace(regexFirst, '<b>$&</b>');
        this.valueMap.contact[wa._id] = this.valueMap.contact[wa._id].replace(regexAll, '<b>$&</b>');
      }
    });
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

  adjustColumns(tableId) {
    this.$timeout(_=>{
      $('#'+tableId).DataTable().columns.adjust();
    }, 0);
  }

  openSendInvitationModal(resend) {
    var that = this;

    let title = (resend) ? "Resend Invitation" : "Send Invitation";

    let state = (resend) ? "invite-no-activation" : "no-invite-no-activation";

    this.WebAccessService.queryState({state: state}, data => {

      var modalInstance = this.$uibModal.open({
        animation: true,
        component: 'webaccessPicker',
        resolve: {
          config: function() {
            return {
              data: data,
              title: title
            }
          }
        },
        size: 'md'
      });

      modalInstance.result.then(
        function (selectedWAIds) {
          that.WebAccessService.sendInvitations({ids: selectedWAIds}, _ => {

            that.$timeout(_=> {
              ["dtAll", "dtActive", "dtBlocked", "dtInitial", "dtInviteNoActivation", "dtNoInviteNoActivation"].forEach(dtId => {
                $('#' + dtId).DataTable().ajax.reload();
              });
            },100);

          }, err => console.log(err));
        },
        function () { /* cancel */ }
      );
    });

  }

  filterData(code) {
    this.filteredData = this.data;
    this.rawFilteredData = angular.copy(this.filteredData);
  }

/*
  getCount(cat) {
    return this.data.reduce((acc, obj) => {
      return acc + (obj.type === cat);
    }, 0);
  }

  setFilter(cat) {
    jQuery("table.dataTable").DataTable().columns(1).search(cat).draw();
  }
*/
  delete(wa) {
    var that = this;

    var waText = "<br/><br/><b>" + wa.email + "</b>";

    var dlg = this.dialogs.confirm("Delete E-Voting Access?", "Do you really want to delete this e-voting access?" + waText);
    dlg.result.then(() => {
      // OK delete it
      that.WebAccessService.delete({id: wa._id},
        () => {
          that.$timeout(_=> {
            ["dtAll", "dtActive", "dtBlocked", "dtInitial", "dtInviteNoActivation", "dtNoInviteNoActivation"].forEach(dtId => {
              $('#' + dtId).DataTable().ajax.reload();
            });
          },100);
        },
        err => {
          alert("Could not delete e-voting access");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.webaccessListSS', [uiRouter])
  .config(routes)
  .component('webaccessListSs', {
    template: require('./webaccess-list-ss.html'),
    controller: WebaccessListSsComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/webaccess/list-ss/webaccess-list-ss.component.js